import { app } from '../../app.module'
// Youtubeアカウントデータのインタフェース
interface IYtPostAverageData {
  views: number
  likes: number
  dislikes: number
  comments: number
  durations: number
}

/**
 * Youtube投稿テーブルの平均
 * @class PostYoutubeTableAverageComponentCtrl
 */
class PostYoutubeTableAverageComponentCtrl {
  private scope: ng.IScope
  // 平均データ
  private averageData: IYtPostAverageData
  // 平均データビュー
  private averageDataView: IYtPostAverageData
  // 投稿数
  private postsCount: number

  constructor($scope) {
    this.scope = $scope
    this.averageDataView = {
      views: 0,
      likes: 0,
      dislikes: 0,
      comments: 0,
      durations: 0,
    }
  }

  /**
   * 平均データが変更時、平均を算出
   */
  public $onChanges(): void {
    this.caculateAverage()
  }

  /**
   * 平均を算出
   * @private
   * @returns {void}
   */
  private caculateAverage(): void {
    this.averageDataView = {
      views: 0,
      likes: 0,
      dislikes: 0,
      comments: 0,
      durations: 0,
    }
    if (this.postsCount === 0 || this.postsCount === undefined || this.postsCount === null) {
      return
    }

    this.averageDataView.views = this.averageData.views / this.postsCount
    this.averageDataView.likes = this.averageData.likes / this.postsCount
    this.averageDataView.dislikes = this.averageData.dislikes / this.postsCount
    this.averageDataView.comments = this.averageData.comments / this.postsCount
    this.averageDataView.durations = this.averageData.durations / this.postsCount
  }
}

app.component('postYoutubeTableAverage', {
  bindings: {
    averageData: '<',
    postsCount: '<',
  },
  template: require('./post-youtube-table-average.pug')(),
  controller: PostYoutubeTableAverageComponentCtrl,
})
